import { useState } from 'react';
import config from '../config';
import { Tool } from '../interfaces';

const useToolAdd = () => {
  const [error, setError] = useState<string | null>(null);

  const toolAdd = async (tool: Tool): Promise<Tool | null> => {
    try {
      const response = await fetch(`${config.centralApiBaseUrl}/tool`, {
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(tool),
      });

      if (!response.ok) {
        throw new Error('Adding tool failed');
      }

      const data = await response.json();
      return data;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      return null;
    }
  };

  return { toolAdd, error };
};

export default useToolAdd;
